<template>
  <div :class="mergeClasses('tw-relative tw-w-max', $attrs.class)">
    <img
      :class="[
        avatarSizes[size],
        shadows[shadow],
        square ? 'tw-rounded-xl' : 'tw-rounded-full',
      ]"
      :src="src"
      alt=""
      test_id="avatar"
      :loading="disableLazyLoading ? 'eager' : 'lazy'"
    />

    <!--Featured icon-->
    <div
      v-if="isFeatured"
      class="tw-absolute tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-white tw-bg-secondary-100"
      :class="star[size].wrapperClasses"
      v-tooltip.right="'Featured mentor'"
    >
      <StarIcon class="tw-text-secondary-400" :class="star[size].iconSize" />
    </div>
  </div>
</template>

<script setup lang="ts">
import StarIcon from '@/assets/images/icons/star.svg'
import { avatarSizes, type AvatarSize } from '@/shared/data/avatarSizes'
import { mergeClasses } from '@/shared/utils/mergeClasses'

// Fix linter error about single-word component name
defineOptions({
  name: 'AvatarImage',
})

type ShadowSize = '' | 'sm' | 'normal' | 'md' | 'lg' | 'xl' | 'xxl'

interface Props {
  src: string
  size?: AvatarSize
  isFeatured?: boolean
  shadow?: ShadowSize
  disableLazyLoading?: boolean
  square?: boolean
}

withDefaults(defineProps<Props>(), {
  size: 'md',
  isFeatured: false,
  shadow: '',
  disableLazyLoading: false,
  square: false,
})

const shadows: Record<ShadowSize, string> = {
  '': '',
  sm: 'tw-shadow-sm',
  normal: 'tw-shadow',
  md: 'tw-shadow-md',
  lg: 'tw-shadow-lg',
  xl: 'tw-shadow-xl',
  xxl: 'tw-shadow-xxl',
}

interface StarConfig {
  wrapperClasses: string
  iconSize: string
}

const star: Record<AvatarSize, StarConfig> = {
  xs: {
    wrapperClasses: 'tw-hidden',
    iconSize: 'tw-w-0 tw-h-0',
  },
  sm: {
    wrapperClasses: 'tw-hidden',
    iconSize: 'tw-w-0 tw-h-0',
  },
  md: {
    wrapperClasses: 'tw--right-1 tw--bottom-1 tw-h-4 tw-w-4',
    iconSize: 'tw-w-2 tw-h-2',
  },
  lg: {
    wrapperClasses: 'tw--right-0.5 tw--bottom-0.5 tw-h-5 tw-w-5',
    iconSize: 'tw-w-[10px] tw-h-[10px]',
  },
  xl: {
    wrapperClasses: 'tw-hidden',
    iconSize: 'tw-w-0 tw-h-0',
  },
  '2xl': {
    wrapperClasses: 'tw-right-0 tw-bottom-0 tw-h-7 tw-w-7',
    iconSize: 'tw-w-[14px] tw-h-[14px]',
  },
  '3xl': {
    wrapperClasses: 'tw-right-1 tw-bottom-1 tw-h-10 tw-w-10',
    iconSize: 'tw-w-5 tw-h-5',
  },
}
</script>
